<script>
    export let squareSize = "100"
</script>

<style>
    .logobackground2{
        background-color: #fff8e7;
        border-radius: 50%;
    }
</style>
<img src="./images/personal_logo.png" class="logobackground2" alt="responsive" style="box-shadow: inset 0px -{squareSize/30}px {squareSize/50}px {squareSize/100}px #292b2c;width:{squareSize}px;height:{squareSize}px">
